/* healeex-hero.js — Trust bar drawer */

(function () {
  'use strict';

  function openDrawer(drawerId, openBtnId) {
    var drawer = document.getElementById(drawerId);
    var openBtn = document.getElementById(openBtnId);
    if (!drawer) return;

    drawer.setAttribute('aria-hidden', 'false');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';

    var panel = drawer.querySelector('.healeex-drawer__panel');
    if (panel) panel.focus();
  }

  function closeDrawer(drawerId, openBtnId) {
    var drawer = document.getElementById(drawerId);
    var openBtn = document.getElementById(openBtnId);
    if (!drawer) return;

    drawer.setAttribute('aria-hidden', 'true');
    if (openBtn) {
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus();
    }
    document.body.style.overflow = '';
  }

  function init() {
    // Open buttons
    document.querySelectorAll('[id^="healeex-trustbar-open-"]').forEach(function (btn) {
      var sectionId = btn.id.replace('healeex-trustbar-open-', '');
      btn.addEventListener('click', function () {
        openDrawer('healeex-trustbar-drawer-' + sectionId, btn.id);
      });
    });

    // Close buttons and overlay clicks
    document.querySelectorAll('[data-close-drawer]').forEach(function (el) {
      el.addEventListener('click', function () {
        var drawerId = el.getAttribute('data-close-drawer');
        var openBtnId = el.getAttribute('data-open-btn');
        closeDrawer(drawerId, openBtnId);
      });
    });

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.healeex-drawer[aria-hidden="false"]').forEach(function (drawer) {
        var closeBtn = drawer.querySelector('.healeex-drawer__close');
        var openBtnId = closeBtn ? closeBtn.getAttribute('data-open-btn') : null;
        closeDrawer(drawer.id, openBtnId);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
